/**
 * Parses a legacy `BlockDefinition.version` value to the integer schema.
 *
 * Accepts:
 *   - positive integer       → returned as-is
 *   - semver string          → leading integer (`'1.0.0'` → 1)
 *   - anything else          → 1
 *
 * Use during read-time migration of `BlockDefinition` and
 * `BakedBlockInstance` records that predate the integer-version contract.
 */
export function parseLegacyBlockVersion(input: unknown): number {
  if (typeof input === 'number' && Number.isInteger(input) && input > 0) {
    return input
  }
  if (typeof input === 'string') {
    const m = /^(\d+)/.exec(input)
    if (m) {
      const n = Number(m[1])
      if (Number.isInteger(n) && n > 0) return n
    }
  }
  return 1
}
